import {
  DELETE_FILE_SUCCESS,
  FETCH_DOC_VERIFY_FAILURE,
  FETCH_DOC_VERIFY_REQUEST,
  FETCH_DOC_VERIFY_SUCCESS,
} from 'constants/documents';
import type { DocVerifyResult } from 'services/payex/payments/types';

export type DocVerifyResultEntry = {
  fileId: string;
  documentId?: string;
} & DocVerifyResult;

export type DocVerifyResultsState = Record<string, DocVerifyResultEntry>;

type DocVerifyAction =
  | {
      type: typeof FETCH_DOC_VERIFY_REQUEST;
      payload: { fileId: string };
    }
  | {
      type: typeof FETCH_DOC_VERIFY_SUCCESS;
      payload: { fileId: string; documentId?: string } & DocVerifyResult;
    }
  | {
      type: typeof FETCH_DOC_VERIFY_FAILURE;
      payload: { fileId: string };
    }
  | {
      type: typeof DELETE_FILE_SUCCESS;
      payload: { fileId: string };
    };

const docVerifyResults = (
  state: DocVerifyResultsState = {},
  action: DocVerifyAction,
): DocVerifyResultsState => {
  switch (action.type) {
    case FETCH_DOC_VERIFY_SUCCESS:
      return { ...state, [action.payload.fileId]: action.payload };
    case DELETE_FILE_SUCCESS: {
      const { [action.payload.fileId]: _removed, ...rest } = state;
      return rest;
    }
    default:
      return state;
  }
};

export { docVerifyResults };
